<template lang="html">
  <div class="selectModeKids" >
    <v-row justify="center">
      <v-col>
        <h1>Szia!</h1>
        <h2>Gyakoroljunk együtt a sorobannal!</h2>
        <p>Először válaszd ki, mit szeretnél gyakorolni!</p>
      </v-col>
    </v-row>
    <v-row justify="center" class="selectmodes">
      <v-col cols="4" md="3" class="mycol">
        <div class="mode sorobanImage" @click="selectMode('readSoroban')">
          <v-icon small>mdi-circle</v-icon>
          <v-icon small>mdi-circle-outline</v-icon>
          <v-icon small>mdi-circle-outline</v-icon>
        </div>
      </v-col>
      <v-col cols="4" md="3" class="mycol">
        <div class="mode numbersImage" @click="selectMode('moveSoroban')">
          1, 2, 3
        </div>
      </v-col>
      <v-col cols="4" md="3" class="mycol">
        <div class="mode complementary" @click="selectMode('complements')">
          4 / 1
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  data(){
    return {

    }
  },
  methods:{
    selectMode(mode){
      this.$router.push({name:'kids', query:{mode: mode}})
      this.$store.dispatch('kids/setGameMode',mode)
      this.$store.dispatch('kids/setLevel', 0)
    },
  },
  mounted(){
    const timeline = gsap.timeline()
    timeline.from(".mode", {duration:2, opacity:0, y:"random(-50, 50)", stagger:0.5, ease:"back"})
  }
}
</script>

<style lang="scss" scoped>
.selectmodes .mycol{
    display: flex;
    justify-content: center;
    align-items: center;

    .mode{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: blue;
    color: white;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    transition: background-color 0.3s ease-out;

    .v-icon{
      color: white;
    }

    &:hover{
      transition: background-color 0.3s ease-out;
      background-color: limegreen;
      cursor: pointer;
    }
  }
}

</style>
